import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-a3b5c954"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "notice-page"
};
const _hoisted_2 = {
  class: "dialog-heading"
};
const _hoisted_3 = {
  key: 0
};
const _hoisted_4 = {
  key: 0,
  class: "message-detail"
};
const _hoisted_5 = ["innerHTML"];
const _hoisted_6 = {
  key: 1,
  class: "notice-body plain"
};
const _hoisted_7 = {
  class: "notice-hero glass-panel"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("h2", null, "通知"), /*#__PURE__*/_createElementVNode("p", null, "校园公告与系统消息")], -1));
const _hoisted_9 = {
  class: "notice-counter"
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "本页", -1));
const _hoisted_11 = {
  class: "notice-list glass-panel"
};
const _hoisted_12 = ["onClick"];
const _hoisted_13 = {
  class: "notice-date",
  "aria-hidden": "true"
};
const _hoisted_14 = {
  class: "notice-content"
};
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "notice-chevron",
  "aria-hidden": "true"
}, "›", -1));
const _hoisted_16 = {
  class: "pagination"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_dialog = _resolveComponent("el-dialog");
  const _component_el_empty = _resolveComponent("el-empty");
  const _component_el_button = _resolveComponent("el-button");
  const _directive_loading = _resolveDirective("loading");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_dialog, {
    modelValue: $setup.detailVisible,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $setup.detailVisible = $event),
    width: "760px",
    "align-center": "",
    "append-to-body": "",
    "destroy-on-close": "",
    "close-on-click-modal": "",
    class: "soft-dialog notice-dialog"
  }, {
    header: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createElementVNode("h3", null, _toDisplayString($setup.activeMessage?.title || "通知详情"), 1), $setup.activeMessage ? (_openBlock(), _createElementBlock("time", _hoisted_3, _toDisplayString($setup.formatMessageTime($setup.activeMessage)), 1)) : _createCommentVNode("", true)])]),
    default: _withCtx(() => [$setup.activeMessage ? (_openBlock(), _createElementBlock("article", _hoisted_4, [$setup.detailHtml ? (_openBlock(), _createElementBlock("div", {
      key: 0,
      class: "notice-body",
      innerHTML: $setup.detailHtml
    }, null, 8, _hoisted_5)) : (_openBlock(), _createElementBlock("div", _hoisted_6, [_createElementVNode("p", null, _toDisplayString($setup.detailPlain || "暂无内容"), 1)]))])) : _createCommentVNode("", true)]),
    _: 1
  }, 8, ["modelValue"]), _createElementVNode("section", _hoisted_7, [_hoisted_8, _createElementVNode("div", _hoisted_9, [_createElementVNode("strong", null, _toDisplayString($setup.messages.length), 1), _hoisted_10])]), _withDirectives((_openBlock(), _createElementBlock("section", _hoisted_11, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.messages, message => {
    return _openBlock(), _createElementBlock("button", {
      key: message.message_id || message.id || message.title,
      class: "notice-card",
      type: "button",
      onClick: $event => $setup.openMessage(message)
    }, [_createElementVNode("div", _hoisted_13, [_createElementVNode("span", null, _toDisplayString($setup.dateParts(message).day), 1), _createElementVNode("small", null, _toDisplayString($setup.dateParts(message).month), 1)]), _createElementVNode("div", _hoisted_14, [_createElementVNode("h3", null, _toDisplayString(message.title || "未命名通知"), 1), _createElementVNode("p", null, _toDisplayString($setup.previewText(message)), 1), _createElementVNode("time", null, _toDisplayString($setup.formatMessageTime(message)), 1)]), _hoisted_15], 8, _hoisted_12);
  }), 128)), !$setup.loading && !$setup.messages.length ? (_openBlock(), _createBlock(_component_el_empty, {
    key: 0,
    description: "暂无通知"
  })) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_16, [_createVNode(_component_el_button, {
    onClick: $setup.prevPage,
    disabled: $setup.currentPage === 1 || $setup.loading
  }, {
    default: _withCtx(() => [_createTextVNode("上一页")]),
    _: 1
  }, 8, ["onClick", "disabled"]), _createElementVNode("span", null, "第 " + _toDisplayString($setup.currentPage) + " 页", 1), _createVNode(_component_el_button, {
    onClick: $setup.nextPage,
    disabled: !$setup.hasNextPage || $setup.loading
  }, {
    default: _withCtx(() => [_createTextVNode("下一页")]),
    _: 1
  }, 8, ["onClick", "disabled"])])])), [[_directive_loading, $setup.loading]])]);
}